var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"content page"},[_c('nav',{staticClass:"breadcrumb"},[_c('router-link',{attrs:{"to":"/"}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" My Account")])],1),_vm._v(" "),_c('h1',[_vm._v("404")]),_c('p',[_vm._v("\""+_vm._s(_vm.path)+"\" is nowhere to be found.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaf6f180","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PageNotFound.vue
// module id = LlU8
// module chunks = 1